// extracted by mini-css-extract-plugin
export default {"container":"PokemonResults_container__lGR2o","pokemon":"PokemonResults_pokemon__fKQ3W"};